import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import {
    Box,
    Button,
    Container,
    Typography,
    Stack
} from '@mui/material';
import Header from '../components/global/Header';
import WrapperSection from '../components/global/WrapperSection';
// import * as pdfjs from 'pdfjs-dist';
// import worker from 'pdfjs-dist/build/pdf.worker.min.js?url';
// pdfjs.GlobalWorkerOptions.workerSrc = worker;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
// pdfjs.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.2.67/pdf.worker.min.js";
const DocumentViewer = () => {
    const { slug } = useParams();
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageWidth, setPageWidth] = useState(800); // قيمة ابتدائية

    // حساب العرض المتجاوب
    useEffect(() => {
        const updateWidth = () => {
            const containerWidth = document.querySelector('.pdf-container')?.offsetWidth;
            setPageWidth(containerWidth ? Math.min(containerWidth, 1200) : 800);
        };

        window.addEventListener('resize', updateWidth);
        updateWidth(); // استدعاء فوري للحساب الأولي

        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    const pdfFile = `/documents/financial-${slug}.pdf`;

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <>
            <Header page={`وثيقة عام ${slug}`} />
            <WrapperSection title={`الوثائق المالية لعام ${slug}`}>
                <Container maxWidth="xl" className="pdf-container">
                    <Box
                        sx={{
                            bgcolor: 'background.paper',
                            p: 3,
                            borderRadius: 2, 
                            boxShadow: 3,
                            overflow: 'hidden',
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <Button
                                component="a"
                                href={pdfFile}
                                download={`financial-${slug}.pdf`}
                                variant="contained"
                                color="primary"
                            >
                                تحميل الوثيقة
                            </Button>
                        </Box>
                        <Document
                            file={pdfFile}
                            onLoadSuccess={onDocumentLoadSuccess}
                        >
                            <Page
                                pageNumber={pageNumber}
                                width={'800'}
                                height={pageWidth * 1.4142}
                                sx={{
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    margin: '0 auto', // توسيط المحتوى
                                    '& .react-pdf__Page__canvas': {
                                        width: '100% !important',
                                        height: 'auto !important',
                                        margin: '0 auto',
                                    },
                                    '& .react-pdf__Page__textContent textLayer': {
                                        display:'none !important'
                                    },
                                    '& .react-pdf__Page__annotations annotationLayer': {
                                        display:'none !important'
                                    },
                                }}
                            />
                        </Document>

                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="center"
                            alignItems="center"
                            sx={{ mt: 3 }}
                        >
                            <Button
                                variant="contained"
                                onClick={() => setPageNumber(Math.max(1, pageNumber - 1))}
                                disabled={pageNumber <= 1}
                            >
                                السابق
                            </Button>

                            <Typography variant="body1" color="text.secondary">
                                صفحة {pageNumber} من {numPages}
                            </Typography>

                            <Button
                                variant="contained"
                                onClick={() => setPageNumber(Math.min(pageNumber + 1, numPages))}
                                disabled={pageNumber >= numPages}
                            >
                                التالي
                            </Button>
                        </Stack>
                    </Box>
                </Container>
            </WrapperSection>
        </>
    );
};

export default DocumentViewer;